import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const FeatureCustomerFirst = () => (
  <>
    <Helmet>
      <title>Customer-First Approach — Support You Can Count On | Salary Uncle</title>
      <meta name="description" content="At Salary Uncle, customers come first. Get fast support, clear communication, and dedicated help at every step of your loan journey." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to Home
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <span className="fd-tag">FEATURE</span>
        <h1>Customer-First Approach</h1>
        <p>Fast support, clear communication, and a dedicated team that puts your needs at the center of every decision.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "Dedicated Support Team", desc: "Reach our team via phone, email, or WhatsApp — Mon to Sat, 9 AM to 7 PM." },
            { title: "AI Chatbot — Myra", desc: "Get instant answers 24/7 from Myra, our AI-powered assistant available right on the site." },
            { title: "No Jargon Communication", desc: "We explain every term, condition, and charge in simple, clear language." },
            { title: "Grievance Redressal", desc: "Formal grievance mechanism with resolution within 7 working days as per RBI norms." },
            { title: "Loan Journey Updates", desc: "Get real-time SMS and email updates at every stage of your loan application." },
            { title: "4.8 / 5 Customer Rating", desc: "Thousands of customers rate us highly for transparency, speed, and support quality." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>Ways to Reach Us</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Call us at +91 87960 41166 — Mon to Sat, 9 AM to 7 PM." },
              { step: "2", text: "Email us at Customercare@salaryuncle.com — response within 24 hours." },
              { step: "3", text: "WhatsApp us at +91 87960 41166 — chat support available." },
              { step: "4", text: "Use Myra, our AI chatbot, for instant 24/7 answers." },
              { step: "5", text: "Visit our office: B-76, 2nd Floor, Wazirpur Industrial Area, Delhi – 110052." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/contact" className="fd-cta-btn">Contact Us</Link>
        </div>
      </div>
    </section>
  </>
);

export default FeatureCustomerFirst;
